import { PageLoadingSupport, LoadedPageContent } from '$components/common'
import { RouteObject } from 'react-router-dom'
import { default as PayAdjustments } from './pay-rules'
import { default as Compliance } from '.'

const basePath = '/time/compliance'
export const complianceRoutes: RouteObject[] = [
  {
    path: `${basePath}/pay-rules/add-package`,
    element: (
      <PageLoadingSupport>
        <PayAdjustments.AddPackage.Component />
      </PageLoadingSupport>
    ),
    loader: PayAdjustments.AddPackage.Loader,
  },
  {
    path: `${basePath}/pay-rules/setup-package/:packageId`,
    element: (
      <PageLoadingSupport>
        <PayAdjustments.SetupPackage.Component />
      </PageLoadingSupport>
    ),
    loader: PayAdjustments.SetupPackage.Loader,
  },
  {
    path: `${basePath}/pay-rules/manage/:packageId`,
    element: (
      <PageLoadingSupport>
        <PayAdjustments.ManagePackage.Component />
      </PageLoadingSupport>
    ),
    loader: PayAdjustments.ManagePackage.Loader,
  },
  {
    path: `${basePath}/pay-rules/create-rule/:packageId`,
    element: (
      <PageLoadingSupport>
        <PayAdjustments.CreateRule.Component />
      </PageLoadingSupport>
    ),
    loader: PayAdjustments.CreateRule.Loader,
  },
  {
    path: `${basePath}/pay-rules/view-rule/:packageId/:ruleId`,
    element: (
      <PageLoadingSupport>
        <PayAdjustments.ViewRule.Component />
      </PageLoadingSupport>
    ),
    loader: PayAdjustments.ViewRule.Loader,
  },
  {
    path: `${basePath}/pay-rules/edit-rule/:packageId/:ruleId`,
    element: (
      <PageLoadingSupport>
        <PayAdjustments.EditRule.Component />
      </PageLoadingSupport>
    ),
    loader: PayAdjustments.EditRule.Loader,
  },
  {
    path: `${basePath}/pay-rules/copy-rule/:newPackageId/:oldPackageId/:ruleId`,
    element: (
      <PageLoadingSupport>
        <PayAdjustments.CopyRule.Component />
      </PageLoadingSupport>
    ),
    loader: PayAdjustments.CopyRule.Loader,
  },
  {
    path: `${basePath}/pay-classifications`,
    element: (
      <LoadedPageContent title={'Pay Classifications'} displayLeftTitle={false}>
        <Compliance.PayClassifications.Component />
      </LoadedPageContent>
    ),
    loader: Compliance.PayClassifications.Loader,
  },
  {
    path: `${basePath}/pay-classifications/manage`,
    element: (
      <LoadedPageContent
        title={'Add Pay Classification'}
        displayLeftTitle={false}
      >
        <Compliance.PayClassifications.Manage.Component />
      </LoadedPageContent>
    ),
    loader: Compliance.PayClassifications.Manage.Loader,
  },
  {
    path: `${basePath}/pay-classifications/add`,
    element: (
      <LoadedPageContent
        title={'Create Custom Pay Classification'}
        displayLeftTitle={false}
      >
        <Compliance.PayClassifications.Add.Component />
      </LoadedPageContent>
    ),
    loader: Compliance.PayClassifications.Add.Loader,
  },
  {
    path: `${basePath}/pay-classifications/:payClassificationId`,
    element: (
      <LoadedPageContent>
        <Compliance.PayClassifications.Edit.Component />
      </LoadedPageContent>
    ),
    loader: Compliance.PayClassifications.Edit.Loader,
  },
  {
    path: `${basePath}/leave-types`,
    element: (
      <LoadedPageContent title={'Leave Types'} displayLeftTitle={false}>
        <Compliance.LeaveTypes.Component />
      </LoadedPageContent>
    ),
    loader: Compliance.LeaveTypes.Loader,
  },
  {
    path: `${basePath}/leave-types/manage`,
    element: (
      <LoadedPageContent title={'Add Leave Type'} displayLeftTitle={false}>
        <Compliance.LeaveTypes.Manage.Component />
      </LoadedPageContent>
    ),
    loader: Compliance.LeaveTypes.Manage.Loader,
  },
  {
    path: `${basePath}/leave-types/add`,
    element: (
      <LoadedPageContent title={'Create Leave Type'} displayLeftTitle={false}>
        <Compliance.LeaveTypes.Add.Component />
      </LoadedPageContent>
    ),
    loader: Compliance.LeaveTypes.Add.Loader,
  },
  {
    path: `${basePath}/leave-types/:leaveTypeId`,
    element: (
      <LoadedPageContent>
        <Compliance.LeaveTypes.Edit.Component />
      </LoadedPageContent>
    ),
    loader: Compliance.LeaveTypes.Edit.Loader,
  },
]
